import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid";
import CheckoutPage from "../Checkout/Checkout";
import "./child.css";
import { Formik } from "formik";
import BookingSummary from "./ticket";
import validationSchema from "../FormModel/validationSchema";
import formInitialValues from "../FormModel/formInitialValues";

const style = {
  position: "absolute" as "absolute",
  top: "1%",
  left: "50%",
  transform: "translate(-50%, 0%)",
  width: "70%",
};

interface ChildCompProps {
  buttonText: string;
  title: string;
  calendarObject: any;
  organisationid: string;
  activityModalOpen: boolean;
  setActivityModalOpen: (value: boolean) => void;
  isLive?:boolean
}

const ChildComp: React.FC<ChildCompProps> = React.memo(({
  title,
  calendarObject,
  organisationid,
  setActivityModalOpen,
  activityModalOpen,
  isLive = false
}) => {
  const [count, setCount] = React.useState(1);

  const handleClose = () => {
    setActivityModalOpen(false);
  };
  function getContrastYIQ(hexcolor: any){
    hexcolor = hexcolor.replace("#", "");
    var r = parseInt(hexcolor.substr(0,2),16);
    var g = parseInt(hexcolor.substr(2,2),16);
    var b = parseInt(hexcolor.substr(4,2),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}

  const handleFormikSubmit = async (values: any, actions: any) => {
    // Handle form submission here
    actions.setSubmitting(false);
  };
  return (
    <React.Fragment>
      <Modal
        open={activityModalOpen}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        style={{ overflowY: "scroll" }}
        classes={{backdrop: "backdrop" }}
      >
        <Box className="main-wrapper">
          <Box sx={{ flexGrow: 1 }}>
            <Formik
              initialValues={formInitialValues}
              validationSchema={validationSchema[count]}
              onSubmit={handleFormikSubmit}
              validateOnChange={true}
              validateOnBlur={true}
            >
              {(formikProps) => (
                <Grid container sx={{ padding: "0.5rem 0.8rem", width: "auto", flexDirection: {
                  xs: 'column', md: 'row'
                }}}>
                  <Grid item lg={8} xl={count === 0 ? 5 : 8} sm={12} xs={12} md={8} sx={{background: "#fff", "margin": "0 auto"}}>
                    <CheckoutPage
                      calendarObject={calendarObject}
                      setCount={setCount}
                      formikProps={formikProps}
                      organisationid={organisationid}
                      closeModal={handleClose}
                      isLive={isLive}
                    />
                  </Grid>
                  {
                    count > 0 && 
                  <Grid item lg={4} sm={12} xs={12} md={4} sx={{background: "#fff", padding: "0.5rem 0.8rem"}}>
                    <div className="bookingSummary">
                      <BookingSummary
                        activeStep={count}
                        title={title}
                        data={formikProps.values}
                        calendarObject={calendarObject}
                        setFieldValue={formikProps.setFieldValue}
                      />
                    </div>
                  </Grid>
                  }
                </Grid>
              )}
            </Formik>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
});

export default ChildComp;
